import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

import { LoadingController } from 'ionic-angular';
import { IonicSelectableComponent } from 'ionic-selectable';

import { ValidatorProvider } from '../../providers/validator/validator';
import { AlertProvider } from '../../providers/alert/alert';
import { AuthProvider } from '../../providers/auth/auth';
import { NetworkMonitorProvider } from '../../providers/network-monitor/network-monitor';
import { EventEmitterProvider } from '../../providers/event-emitter/event-emitter';

import { RegistrationPersonal } from '../../models/registrationpersonal';

/**
 * Generated class for the UpdateRegistrationPersonalPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'page-update-registration-personal',
  templateUrl: 'update-registration-personal.html',
})
export class UpdateRegistrationPersonalPage {

  private user: any;
  public registrationPersonal: RegistrationPersonal;
  public genres: any[] = [];
  public nationalities: any[] = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertProvider: AlertProvider,
    private loadingCtrl: LoadingController,
    private authProvider: AuthProvider,
    private validatorProvider: ValidatorProvider,
    private networkMonitorProvider: NetworkMonitorProvider,
    private eventEmitterProvider: EventEmitterProvider
  ) {
    this.registrationPersonal = new RegistrationPersonal();
    this.genres = [
      { id: 'F', name: 'Feminino' },
      { id: 'M', name: 'Masculino' },
      { id: 'O', name: 'Outros' },
    ];
    this.nationalities = [
      { id: 'BRA', name: 'Brasil' },
      { id: 'AFG', name: 'Afeganistão' },
      { id: 'ZAF', name: 'África do Sul' },
      { id: 'ALB', name: 'Albânia' },
      { id: 'DEU', name: 'Alemanha' },
      { id: 'AND', name: 'Andorra' },
      { id: 'AGO', name: 'Angola' },
      { id: 'AIA', name: 'Anguilla' },
      { id: 'ATA', name: 'Antárctida' },
      { id: 'ATG', name: 'Antígua e Barbuda' },
      { id: 'ANT', name: 'Antilhas Holandesas' },
      { id: 'SAU', name: 'Arábia Saudita' },
      { id: 'DZA', name: 'Argélia' },
      { id: 'ARG', name: 'Argentina' },
      { id: 'ARM', name: 'Arménia' },
      { id: 'ABW', name: 'Aruba' },
      { id: 'AUS', name: 'Austrália' },
      { id: 'AUT', name: 'Austria' },
      { id: 'AZE', name: 'Azerbaijão' },
      { id: 'BHS', name: 'Bahamas' },
      { id: 'BHR', name: 'Bahrein' },
      { id: 'BGD', name: 'Bangladesh' },
      { id: 'BRB', name: 'Barbados' },
      { id: 'BEL', name: 'Bélgica' },
      { id: 'BLZ', name: 'Belize' },
      { id: 'BEN', name: 'Benim' },
      { id: 'BMU', name: 'Bermudas' },
      { id: 'BLR', name: 'Bielorrússia' },
      { id: 'BOL', name: 'Bolívia' },
      { id: 'BIH', name: 'Bósnia e Herzegovina' },
      { id: 'BWA', name: 'Botsuana' },
      //{ id: 'BRA', name: 'Brasil'},
      { id: 'BRN', name: 'Brunei' },
      { id: 'BGR', name: 'Bulgária' },
      { id: 'BFA', name: 'Burkina Faso' },
      { id: 'BDI', name: 'Burundi' },
      { id: 'BTN', name: 'Butão' },
      { id: 'CPV', name: 'Cabo Verde' },
      { id: 'CMR', name: 'Camarões' },
      { id: 'KHM', name: 'Camboja' },
      { id: 'CAN', name: 'Canadá' },
      { id: 'KAZ', name: 'Cazaquistão' },
      { id: 'TCD', name: 'Chade' },
      { id: 'CHL', name: 'Chile' },
      { id: 'CHN', name: 'China' },
      { id: 'CYP', name: 'Chipre' },
      { id: 'COL', name: 'Colômbia' },
      { id: 'COM', name: 'Comores' },
      { id: 'COG', name: 'Congo' },
      { id: 'PRK', name: 'Coreia do Norte' },
      { id: 'KOR', name: 'Coreia do Sul' },
      { id: 'CIV', name: 'Costa do Marfim' },
      { id: 'CRI', name: 'Costa Rica' },
      { id: 'HRV', name: 'Croácia' },
      { id: 'CUB', name: 'Cuba' },
      { id: 'DNK', name: 'Dinamarca' },
      { id: 'DJI', name: 'Djibouti' },
      { id: 'DMA', name: 'Dominica' },
      { id: 'EGY', name: 'Egito' },
      { id: 'SLV', name: 'El Salvador' },
      { id: 'ARE', name: 'Emirados Árabes Unidos' },
      { id: 'ECU', name: 'Equador' },
      { id: 'ERI', name: 'Eritreia' },
      { id: 'SCO', name: 'Escócia' },
      { id: 'SVK', name: 'Eslováquia' },
      { id: 'SVN', name: 'Eslovênia' },
      { id: 'ESP', name: 'Espanha' },
      { id: 'FSM', name: 'Estados Federados da Micronésia' },
      { id: 'USA', name: 'Estados Unidos' },
      { id: 'EST', name: 'Estônia' },
      { id: 'ETH', name: 'Etiópia' },
      { id: 'FJI', name: 'Fiji' },
      { id: 'PHL', name: 'Filipinas' },
      { id: 'FIN', name: 'Finlândia' },
      { id: 'FRA', name: 'França' },
      { id: 'GAB', name: 'Gabão' },
      { id: 'GMB', name: 'Gâmbia' },
      { id: 'GHA', name: 'Gana' },
      { id: 'GEO', name: 'Geórgia' },
      { id: 'GIB', name: 'Gibraltar' },
      { id: 'GRD', name: 'Granada' },
      { id: 'GRC', name: 'Grécia' },
      { id: 'GRL', name: 'Gronelândia' },
      { id: 'GLP', name: 'Guadalupe' },
      { id: 'GUM', name: 'Guam' },
      { id: 'GTM', name: 'Guatemala' },
      { id: 'GGY', name: 'Guernsey' },
      { id: 'GUY', name: 'Guiana' },
      { id: 'GUF', name: 'Guiana Francesa' },
      { id: 'GIN', name: 'Guiné' },
      { id: 'GNQ', name: 'Guiné Equatorial' },
      { id: 'GNB', name: 'Guiné-Bissau' },
      { id: 'HTI', name: 'Haiti' },
      { id: 'HND', name: 'Honduras' },
      { id: 'HKG', name: 'Hong Kong' },
      { id: 'HUN', name: 'Hungria' },
      { id: 'YEM', name: 'Iémen' },
      { id: 'BVT', name: 'Ilha Bouvet' },
      { id: 'CXR', name: 'Ilha Christmas' },
      { id: 'IMN', name: 'Ilha de Man' },
      { id: 'HMD', name: 'Ilha Heard e Ilhas McDonald' },
      { id: 'NFK', name: 'Ilha Norfolk' },
      { id: 'ALA', name: 'Ilhas Alanda' },
      { id: 'CYM', name: 'Ilhas Cayman' },
      { id: 'CCK', name: 'Ilhas Cocos' },
      { id: 'COK', name: 'Ilhas Cook' },
      { id: 'FRO', name: 'Ilhas Feroé' },
      { id: 'SGS', name: 'Ilhas Geórgia do Sul e Sandwich do Sul' },
      { id: 'FLK', name: 'Ilhas Malvinas' },
      { id: 'MHL', name: 'Ilhas Marshall' },
      { id: 'UMI', name: 'Ilhas Menores Distantes dos Estados Unidos' },
      { id: 'SLB', name: 'Ilhas Salomão' },
      { id: 'VIR', name: 'Ilhas Virgens Americanas' },
      { id: 'VGB', name: 'Ilhas Virgens Britânicas' },
      { id: 'IND', name: 'Índia' },
      { id: 'IDN', name: 'Indonésia' },
      { id: 'ENG', name: 'Inglaterra' },
      { id: 'IRN', name: 'Irã' },
      { id: 'IRQ', name: 'Iraque' },
      { id: 'IRL', name: 'Irlanda' },
      { id: 'NIR', name: 'Irlanda do Norte' },
      { id: 'ISL', name: 'Islândia' },
      { id: 'ISR', name: 'Israel' },
      { id: 'ITA', name: 'Itália' },
      { id: 'JAM', name: 'Jamaica' },
      { id: 'JPN', name: 'Japão' },
      { id: 'JEY', name: 'Jersey' },
      { id: 'JOR', name: 'Jordânia' },
      { id: 'KIR', name: 'Kiribati' },
      { id: 'KOS', name: 'Kosovo' },
      { id: 'KWT', name: 'Kuwait' },
      { id: 'LAO', name: 'Laos' },
      { id: 'LSO', name: 'Lesoto' },
      { id: 'LVA', name: 'Letônia' },
      { id: 'LBN', name: 'Líbano' },
      { id: 'LBR', name: 'Libéria' },
      { id: 'LBY', name: 'Líbia' },
      { id: 'LIE', name: 'Liechtenstein' },
      { id: 'LTU', name: 'Lituânia' },
      { id: 'LUX', name: 'Luxemburgo' },
      { id: 'MAC', name: 'Macau' },
      { id: 'MKD', name: 'Macedónia' },
      { id: 'MDG', name: 'Madagáscar' },
      { id: 'MYS', name: 'Malásia' },
      { id: 'MWI', name: 'Malaui' },
      { id: 'MDV', name: 'Maldivas' },
      { id: 'MLI', name: 'Mali' },
      { id: 'MLT', name: 'Malta' },
      { id: 'MNP', name: 'Marianas Setentrionais' },
      { id: 'MAR', name: 'Marrocos' },
      { id: 'MTQ', name: 'Martinica' },
      { id: 'MUS', name: 'Maurícia' },
      { id: 'MRT', name: 'Mauritânia' },
      { id: 'MYT', name: 'Mayotte' },
      { id: 'MEX', name: 'México' },
      { id: 'MMR', name: 'Mianmar' },
      { id: 'MOZ', name: 'Moçambique' },
      { id: 'MDA', name: 'Moldávia' },
      { id: 'MCO', name: 'Mónaco' },
      { id: 'MNG', name: 'Mongólia' },
      { id: 'MNE', name: 'Montenegro' },
      { id: 'MSR', name: 'Montserrat' },
      { id: 'NAM', name: 'Namíbia' },
      { id: 'NRU', name: 'Nauru' },
      { id: 'NPL', name: 'Nepal' },
      { id: 'NIC', name: 'Nicarágua' },
      { id: 'NER', name: 'Níger' },
      { id: 'NGA', name: 'Nigéria' },
      { id: 'NIU', name: 'Niue' },
      { id: 'NOR', name: 'Noruega' },
      { id: 'NCL', name: 'Nova Caledônia' },
      { id: 'NZL', name: 'Nova Zelândia' },
      { id: 'OMN', name: 'Omã' },
      { id: 'WAL', name: 'País de Gales' },
      { id: 'NLD', name: 'Países Baixos' },
      { id: 'PLW', name: 'Palau' },
      { id: 'PSE', name: 'Palestina' },
      { id: 'PAN', name: 'Panamá' },
      { id: 'PNG', name: 'Papua-Nova Guiné' },
      { id: 'PAK', name: 'Paquistão' },
      { id: 'PRY', name: 'Paraguai' },
      { id: 'PER', name: 'Peru' },
      { id: 'PCN', name: 'Pitcairn' },
      { id: 'PYF', name: 'Polinésia Francesa' },
      { id: 'POL', name: 'Polónia' },
      { id: 'PRI', name: 'Porto Rico' },
      { id: 'PRT', name: 'Portugal' },
      { id: 'QAT', name: 'Qatar' },
      { id: 'KEN', name: 'Quênia' },
      { id: 'KGZ', name: 'Quirguistão' },
      { id: 'GBR', name: 'Reino Unido' },
      { id: 'CAF', name: 'República Centro-Africana' },
      { id: 'CZE', name: 'República Checa' },
      { id: 'COD', name: 'República Democrática do Congo' },
      { id: 'DOM', name: 'República Dominicana' },
      { id: 'REU', name: 'Reunião' },
      { id: 'ROU', name: 'Romênia' },
      { id: 'RWA', name: 'Ruanda' },
      { id: 'RUS', name: 'Rússia' },
      { id: 'ESH', name: 'Saara Ocidental' },
      { id: 'MAF', name: 'Saint Martin' },
      { id: 'BLM', name: 'Saint-Barthélemy' },
      { id: 'WSM', name: 'Samoa' },
      { id: 'ASM', name: 'Samoa Americana' },
      { id: 'SHN', name: 'Santa Helena (território)' },
      { id: 'LCA', name: 'Santa Lúcia' },
      { id: 'KNA', name: 'São Cristóvão e Névis' },
      { id: 'SMR', name: 'São Marinho' },
      { id: 'SPM', name: 'São Pedro e Miquelão' },
      { id: 'STP', name: 'São Tomé e Príncipe' },
      { id: 'VCT', name: 'São Vicente e Granadinas' },
      { id: 'SEN', name: 'Senegal' },
      { id: 'SLE', name: 'Serra Leoa' },
      { id: 'SRB', name: 'Sérvia' },
      { id: 'SYC', name: 'Seychelles' },
      { id: 'SGP', name: 'Singapura' },
      { id: 'SYR', name: 'Síria' },
      { id: 'SOM', name: 'Somália' },
      { id: 'LKA', name: 'Sri Lanka' },
      { id: 'SWZ', name: 'Suazilândia' },
      { id: 'SDN', name: 'Sudão' },
      { id: 'SWE', name: 'Suécia' },
      { id: 'CHE', name: 'Suíça' },
      { id: 'SUR', name: 'Suriname' },
      { id: 'SJM', name: 'Svalbard' },
      { id: 'TJK', name: 'Tadjiquistão' },
      { id: 'THA', name: 'Tailândia' },
      { id: 'TWN', name: 'Taiwan' },
      { id: 'TZA', name: 'Tanzânia' },
      { id: 'ATF', name: 'Terras Austrais e Antárticas Francesas' },
      { id: 'IOT', name: 'Território Britânico do Oceano Índico' },
      { id: 'TLS', name: 'Timor-Leste' },
      { id: 'TGO', name: 'Togo' },
      { id: 'TON', name: 'Tonga' },
      { id: 'TKL', name: 'Toquelau' },
      { id: 'TTO', name: 'Trinidad e Tobago' },
      { id: 'TUN', name: 'Tunísia' },
      { id: 'TCA', name: 'Turcas e Caicos' },
      { id: 'TKM', name: 'Turcomenistão' },
      { id: 'TUR', name: 'Turquia' },
      { id: 'TUV', name: 'Tuvalu' },
      { id: 'UKR', name: 'Ucrânia' },
      { id: 'UGA', name: 'Uganda' },
      { id: 'URY', name: 'Uruguai' },
      { id: 'UZB', name: 'Uzbequistão' },
      { id: 'VUT', name: 'Vanuatu' },
      { id: 'VAT', name: 'Vaticano' },
      { id: 'VEN', name: 'Venezuela' },
      { id: 'VNM', name: 'Vietname' },
      { id: 'WLF', name: 'Wallis e Futuna' },
      { id: 'ZMB', name: 'Zâmbia' },
      { id: 'ZWE', name: 'Zimbábue' },
    ];

    this.user = this.authProvider.getUser();
    if (this.user) {
      this.registrationPersonal.birthAt = this.user.birthAt;
      this.registrationPersonal.genre = this.user.genre;
      this.registrationPersonal.nationality = this.user.nationality;
      this.registrationPersonal.birthPlace = this.user.birthPlace;
    }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad UpdateRegistrationPersonalPage');
  }

  onBack() {
    this.navCtrl.pop({
      animation: 'ios-transition'
    });
  }

  onGenreChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    console.log('genre:', event.value);
  }

  onNationalityChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    console.log('nationality:', event.value);
  }

  doSave() {
    if (!this.networkMonitorProvider.isOnline()) {
      this.alertProvider.doAlert('É necessário estar conectado na Internet para salvar os dados pessoais.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationPersonal.birthAt)) {
      this.alertProvider.doAlert('Forneça sua data de nascimento.', 'Atenção');
    } else if (!this.validatorProvider.isDate(this.registrationPersonal.birthAt)) {
      this.alertProvider.doAlert('Forneça uma data válida.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationPersonal.genre)) {
      this.alertProvider.doAlert('Forneça seu sexo.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationPersonal.nationality)) {
      this.alertProvider.doAlert('Forneça sua nacionalidade.', 'Atenção');
    } else if (this.validatorProvider.isEmpty(this.registrationPersonal.birthPlace)) {
      this.alertProvider.doAlert('Forneça sua naturalidade.', 'Atenção');
    } else {
      let that = this;
      this.alertProvider.doConfirm('Deseja salvar seus dados pessoais?', () => {
        let loader = that.loadingCtrl.create({
          content: 'Enviando pedido...',
          // duration: 3000
        });
        loader.present();

        that.authProvider.updatePersonal(that.registrationPersonal).subscribe((response: any) => {
          if ((response) && (response.updated)) {
            that.alertProvider.doAlert('Seus dados pessoais foram salvos com sucesso.', 'Informação');
            loader.dismiss();

            // Update local user data
            that.user.birthAt = that.registrationPersonal.birthAt;
            that.user.genre = that.registrationPersonal.genre;
            that.user.nationality = that.registrationPersonal.nationality;
            that.user.birthPlace = that.registrationPersonal.birthPlace;

            that.authProvider.setUser(that.user);
            that.eventEmitterProvider.get('registration_updated').emit(that.user);

            that.onBack();
          } else {
            loader.dismiss();
            that.alertProvider.doAlert('Houve problemas ao tentar salvar seus dados pessoais. Tente novamente mais tarde.', 'Atenção');
          }
        }, (error: any) => {
          console.log(error);
          loader.dismiss();
          that.alertProvider.doAlert('Houve problemas ao tentar salvar seus dados pessoais. Tente novamente mais tarde.', 'Atenção');
        });
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/update-registration-personal/update-registration-personal.ts